import {
	Box,
	Button,
	Card,
	CardHeader,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";

import axios from "axios";
import { applyPagination } from "src/Helpers/utils";
import { url } from "src/Helpers/utils/constants";
import { IGuest } from "src/Types/module/guestAndSpeaker/type/guestAndSpeaker";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import CreateGuest from "./CreateGuestAndSpeaker";
import GuestAndSpeakerTableRow from "./GuestAndSpeakerTableRow";
import { useApiQuery } from "src/hooks/useApiQuery";

const AllGuestList = () => {
	const [page, setPage] = useState<number>(0);
	const [limit, setLimit] = useState<number>(25);

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

	// Modal
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const { data: guests, isLoading } = useApiQuery<any[]>({
		endPoint: `/api/fair/get/guest-speaker/for-admin/guest-speaker-type/all`,
		queryKeys: ["Guests"],
	});

	const handlePageChange = (event: any, newPage: number): void => {
		setPage(newPage);
	};

	const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
		setLimit(parseInt(event.target.value));
	};

	const paginatedData = applyPagination(guests, page, limit);

	return (
		<Box sx={{ m: 2 }}>
			<Card>
				<CardHeader
					action={
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								gap: 2,
							}}
						>
							<Button
								onClick={() => handleOpen()}
								variant="contained"
							>
								Create Guest & Speaker
							</Button>
						</Box>
					}
					title="Guest & Speaker List"
				/>

				<Divider />
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>ID</TableCell>
								<TableCell>Photo</TableCell>
								<TableCell>Name</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Type</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : guests?.length ? (
							<TableBody>
								{paginatedData.map((singleGuest: IGuest) => {
									return (
										<GuestAndSpeakerTableRow
											key={singleGuest.guest_speaker_id}
											guest={singleGuest}
											allGuest={guests}
										/>
									);
								})}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>
				<Box p={2}>
					<TablePagination
						component="div"
						count={guests?.length}
						onPageChange={handlePageChange}
						onRowsPerPageChange={handleLimitChange}
						page={page}
						rowsPerPage={limit}
						rowsPerPageOptions={[25, 50, 75, 100]}
					/>
				</Box>
				{/* Modal */}
				<Dialog
					fullScreen={fullScreen}
					open={open}
					maxWidth="md"
					onClose={handleClose}
					aria-labelledby="responsive-dialog-title"
				>
					<DialogContent>
						<Box sx={{ mb: 2 }}>
							<Typography sx={{ mb: 2 }}>
								{" "}
								Create Guest
							</Typography>
						</Box>
						<CreateGuest
							handleClose={handleClose}
							allGuest={guests}
						/>
					</DialogContent>
					<DialogActions>
						<Button autoFocus onClick={handleClose}>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</Card>
		</Box>
	);
};

export default AllGuestList;
